import { render, staticRenderFns } from "./AssessmentError.vue?vue&type=template&id=4ef23d87&scoped=true&"
import script from "./AssessmentError.vue?vue&type=script&lang=ts&"
export * from "./AssessmentError.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentError.vue?vue&type=style&index=0&id=4ef23d87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef23d87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
